import { AxiosInstance } from "axios";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

const SUPPORTED_LANGUAGES = ["pl", "en"];
export const LANG_STORAGE_KEY = "lang";

export const useLanguage = () => {
  const { i18n, t } = useTranslation();

  const languages = [
    { name: t("common.polish"), code: "pl", selected: i18n.language === "pl" },
    {
      name: t("common.english"),
      code: "en",
      selected: i18n.language === "en",
    },
  ].map((x) => ({
    ...x,
    selected: x.code === i18n.language,
    label: `${x.code.toUpperCase()} - ${x.name}`,
    shortLabel: x.code.toUpperCase(),
  }));

  useEffect(() => {
    const code = localStorage.getItem(LANG_STORAGE_KEY);
    if (code && SUPPORTED_LANGUAGES.includes(code)) {
      i18n.changeLanguage(code);
      globalThis.OneTrust?.changeLanguage(code);
    } else {
      localStorage.setItem(LANG_STORAGE_KEY, i18n.language);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const selectedLanguage = languages.find((x) => x.selected);

  return {
    languages,
    selectedLanguage,
    onLanguageChange: (code: string) => {
      if (SUPPORTED_LANGUAGES.includes(code)) {
        i18n.changeLanguage(code);
        globalThis.OneTrust?.changeLanguage(code);
        localStorage.setItem(LANG_STORAGE_KEY, code);
      }
    },
  };
};

const requestLanguageHeader: string = "X-Language-Code";
export const setupLanguageInterceptor = (axios: AxiosInstance): void => {
  axios.interceptors.request.use((config) => {
    config.headers[requestLanguageHeader] =
      localStorage.getItem(LANG_STORAGE_KEY) || SUPPORTED_LANGUAGES[0];
    return config;
  });
};
